<template>
  <div>
    <label class="text-xs font-black uppercase text-gray-600 block mb-2">🎨 Icône de la file</label>

    <!-- 🎨 NOUVEAUX: Icônes Pixel Art personnalisées -->
    <div class="mb-4">
      <h3 class="text-xs font-bold text-indigo-600 mb-2 flex items-center gap-2">
        <span>✨ Icônes Pixel Art (Personnalisées)</span>
        <span class="text-[10px] bg-indigo-100 text-indigo-600 px-2 py-0.5 rounded-full">Nouveau!</span>
      </h3>
      <div class="grid grid-cols-4 gap-3">
        <button
          v-for="icon in pixelArtIcons"
          :key="icon.name"
          type="button"
          @click="selectIcon(icon.name)"
          :class="[
            'p-4 rounded-xl border-2 transition-all hover:scale-105 relative',
            selectedIcon === icon.name
              ? 'border-indigo-500 bg-indigo-50 shadow-lg'
              : 'border-gray-200 bg-white hover:border-indigo-300'
          ]"
          :title="icon.label"
        >
          <div class="text-3xl mb-1">{{ icon.emoji }}</div>
          <p class="text-[8px] font-bold mt-1 text-gray-600">{{ icon.label }}</p>
          <div v-if="selectedIcon === icon.name" class="absolute top-1 right-1 w-5 h-5 bg-indigo-500 rounded-full flex items-center justify-center">
            <span class="text-white text-xs">✓</span>
          </div>
        </button>
      </div>
    </div>
    
  </div>
</template>

<script>

export default {
  name: 'IconSelector',

  props: {
    modelValue: {
      type: String,
      default: 'pill'
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selectedIcon: this.modelValue,
      // ✨ NOUVELLES icônes Pixel Art personnalisées
      pixelArtIcons: [
        { name: 'rabbit', label: 'Lapin', emoji: '🐰' },
        { name: 'turtle', label: 'Tortue', emoji: '🐢' },
        { name: 'star', label: 'Étoile', emoji: '⭐' },
        { name: 'heart', label: 'Cœur', emoji: '❤️' }
      ],
      // 🏥 Icônes médicales SVG existantes
      pharmacyIcons: [
        { name: 'prescription', label: 'Ordonnance' },
        { name: 'cross', label: 'Croix' },
        { name: 'capsule', label: 'Capsule' },
        { name: 'syringe', label: 'Seringue' },
        { name: 'heart-pulse', label: 'Cardiologie' },
        { name: 'stethoscope', label: 'Stéthoscope' },
        { name: 'microscope', label: 'Labo' },
        { name: 'flask', label: 'Analyse' },
        { name: 'thermometer', label: 'Température' },
        { name: 'bandage', label: 'Pansement' },
        { name: 'clipboard', label: 'Consultation' },
        { name: 'calendar', label: 'RDV' },
        { name: 'user-check', label: 'Patient' },
        { name: 'droplet', label: 'Vaccin' },
        { name: 'eye', label: 'Ophtalmologie' },
        { name: 'activity', label: 'Urgence' }
      ]
    }
  },
  watch: {
    modelValue(newVal) {
      this.selectedIcon = newVal
    }
  },
  methods: {
    selectIcon(iconName) {
      // ✅ Si l'icône est déjà sélectionnée, on la désélectionne (null)
      // Sinon, on la sélectionne
      if (this.selectedIcon === iconName) {
        this.selectedIcon = null
        this.$emit('update:modelValue', null)
      } else {
        this.selectedIcon = iconName
        this.$emit('update:modelValue', iconName)
      }
    }
  }
}
</script>
